import React from "react";
import ReactMarkdown from "react-markdown";

interface MarkdownContentProps {
  children: string;
  emptyText?: string;
  className?: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({
  children,
  emptyText = "No content.",
  className = "",
}) => (
  <div
    className={`prose prose-sm max-w-none dark:prose-invert text-[var(--foreground)] ${className}`}
  >
    <ReactMarkdown
      components={{
        h1: ({ node, children, ...props }) => (
          <h1 className="text-xl font-semibold mb-3 text-[var(--foreground)]" {...props}>
            {children}
          </h1>
        ),
        h2: ({ node, children, ...props }) => (
          <h2 className="text-lg font-semibold mb-2 text-[var(--foreground)]" {...props}>
            {children}
          </h2>
        ),
        h3: ({ node, children, ...props }) => (
          <h3 className="text-base font-semibold mb-2 text-[var(--foreground)]" {...props}>
            {children}
          </h3>
        ),
        p: ({ node, ...props }) => (
          <p className="mb-2 leading-relaxed text-[var(--foreground)]" {...props} />
        ),
        ul: ({ node, ...props }) => (
          <ul className="list-disc pl-5 mb-2 space-y-1 text-[var(--foreground)]" {...props} />
        ),
        ol: ({ node, ...props }) => (
          <ol className="list-decimal pl-5 mb-2 space-y-1 text-[var(--foreground)]" {...props} />
        ),
        li: ({ node, ...props }) => (
          <li className="leading-relaxed text-[var(--foreground)]" {...props} />
        ),
        code: ({ node, inline, ...props }: any) =>
          inline ? (
            <code
              className="bg-[var(--muted)] px-1 py-0.5 rounded text-[0.85em] font-mono text-[var(--foreground)]"
              {...props}
            />
          ) : (
            <code
              className="block bg-[var(--muted)] p-3 rounded-md text-xs font-mono overflow-x-auto text-[var(--foreground)]"
              {...props}
            />
          ),
        pre: ({ node, ...props }) => (
          <pre className="my-2 overflow-x-auto" {...props} />
        ),
        blockquote: ({ node, ...props }) => (
          <blockquote
            className="border-l-2 border-[var(--border)] pl-3 my-2 text-[var(--foreground-muted)]"
            {...props}
          />
        ),
        strong: ({ node, ...props }) => (
          <strong className="font-semibold text-[var(--foreground)]" {...props} />
        ),
      }}
    >
      {children?.trim() || `_${emptyText}_`}
    </ReactMarkdown>
  </div>
);
